import React from 'react';
import {Helmet} from "react-helmet";
import Seo from "./seo";

export default function LiveSeo(props) {
    return <Helmet>
        <Seo {...props} />
    </Helmet>;
}
